import { eppExpLanguageDef } from './epp-exp/epp-exp.language'

/** monaco 加载完成向外通知 */
let resolveMonacoLoadPromise
export const monacoLoadPromise = new Promise((resolve) => {
  resolveMonacoLoadPromise = resolve
})

export const LANG_EPP_EXP = 'eppExp'

/** 加载完成后 */
export function handleMonacoLoad () {
  // epp exp
  monaco.languages.register({ id: LANG_EPP_EXP })
  monaco.languages.setMonarchTokensProvider(LANG_EPP_EXP, eppExpLanguageDef)
  registerSysVarsCompletion(LANG_EPP_EXP)

  initTheme()
  resolveMonacoLoadPromise()
}

export const sysVars = [{
  name: 'username',
  doc: '当前用户名，字符串'
}, {
  name: 'username2',
  doc: '方法大幅度反对法大幅度反对法的的方式反对反对犯得上方法的'
}, {
  name: 'pp',
  doc: '大苏打实打实大大实打实大苏打'
}, {
  name: 'time',
  doc: '当范德萨范德萨分'
}]

/** 系统变量自动补全注册 */
export function registerSysVarsCompletion (langId: string) {
  monaco.languages.registerCompletionItemProvider(langId, {
    provideCompletionItems () {
      return {
        suggestions: [
          {
            label: 'sys',
            kind: monaco.languages.CompletionItemKind.Class,
            documentation: '系统变量',
            insertText: 'sys',
            range: null
          }
        ]
      }
    }
  })
  monaco.languages.registerCompletionItemProvider(langId, {
    provideCompletionItems (model, position) {
      return {
        suggestions: sysVars.map(sysVar => {
          return {
            label: sysVar.name,
            kind: monaco.languages.CompletionItemKind.Field,
            insertText: sysVar.name,
            range: null,
            detail: '(系统变量) username: string',
            documentation: sysVar.doc
          }
        })
      }
    },
    triggerCharacters: ['.'] // 触发提示的字符，可以写多个
  })
}

function initTheme () {
  monaco.editor.defineTheme('eppTheme', {
    base: 'vs-dark',
    inherit: true,
    rules: [
      { token: 'epp-default', foreground: 'ffc107' },
      { token: 'epp-brackets', foreground: '78dce8' },
      { token: 'epp-number-operator', foreground: 'a9dc76' },
      { token: 'epp-logic-operator', foreground: 'ff0081' },
      { token: 'epp-sys-var', foreground: 'F59BAC', fontStyle: 'bold' },
      { token: 'epp-function', foreground: '607d8b' },
      { token: 'epp-number', foreground: '#ff6188' },
    ],
    colors: {
      'editor.foreground': '#F9FFEE',
      'editor.background': '#1a1d24',
      'editorCursor.foreground': '#ffffff',
      'editor.lineHighlightBackground': '#ffffff15',
      'editorLineNumber.foreground': '#008800',
      'editor.selectionBackground': '#ffffff21',
      'editor.inactiveSelectionBackground': '#ffffff41'
    }
  })
}
